<template>
  <section class="content-plans">
    <div class="content-plans-itens">
      <Breadcrumb :links="links"/>
      <div class="content-plans-itens-body">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3">
            <router-link tag="a" :to="{name: 'RegisterHumorQuestions'}" class="content--card-register" style="min-height: 200px">
              <img class="img-fluid" src="@/assets/img/image-plus.png" alt="image plus" title="image plus"/>
            </router-link>
          </div>
          <div class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3" v-for="(humor, index) in humorQuestions.data" :key="index">
            <CardHumorQuestions :humor="humor"/>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/Index';
import CardHumorQuestions from '@/views/Humor/components/CardHumorQuestions';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      links: [
      {
          name: 'Humor',
          routerName: 'Humor'
        },
        {
          name: 'Listar Perguntas/Respostas',
          routerName: 'ListMoods'
        },
      ],
    }
  },
  computed: {
    ...mapGetters('Humor', ['humorQuestions'])
  },
  components: {
    Breadcrumb,
    CardHumorQuestions
  },
  methods: {
    ...mapActions('Humor', ['consultHumorQuestions'])
  },
  mounted() {
    this.consultHumorQuestions();
  }
}
</script>

<style lang="scss">
</style>
